/* ============================================================
   prodnamo — lecteur video (medias produit)
   Reprend les MECANIQUES du lecteur du beat store (beat-store.js) :
     - progression redessinee en requestAnimationFrame + transition .1s
     - glisser la barre : visuel immediat, deplacement de la video
       limite (~8/s) puis valide au relache -> pas de saccade
     - infobulle du temps sous le curseur
     - volume : popup au survol, ferme 200ms apres la sortie ;
       molette +-5 % (popup visible 1 s) ; clic = coupe / retablit
       (dernier niveau > 5 %, sinon 70 %) ; glisser = son applique
       tout de suite, visuel en requestAnimationFrame
     - volume memorise (coupe = volume 0, comme audio_volume)

   Amelioration progressive : Dawn rend un <video controls> classique,
   ce script retire les controles natifs. Sans lui, le lecteur natif
   reste fonctionnel. La video est injectee par Dawn au clic sur le
   poster (<template> dans <deferred-media>) : on l'attend apres le clic.
   ============================================================ */
(function () {
  'use strict';

  /* icones reprises du lecteur du beat store */
  var ICON = {
    play:  '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4.5 2L12.5 8L4.5 14V2Z"/></svg>',
    pause: '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="4" y="2" width="3" height="12"/><rect x="9" y="2" width="3" height="12"/></svg>',
    vol:   '<svg viewBox="1 4 20.5 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>',
    mute:  '<svg viewBox="1 4 20.5 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/><path d="M17 11l4 4m0-4l-4 4"/></svg>',
    fs:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4"/></svg>',
    fsx:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4v4a1 1 0 0 1-1 1H4M20 9h-4a1 1 0 0 1-1-1V4M15 20v-4a1 1 0 0 1 1-1h4M4 15h4a1 1 0 0 1 1 1v4"/></svg>'
  };

  /* volume memorise (localStorage peut lever en navigation privee) */
  var KEY = 'pnvideo_volume';        // volume courant (0 = coupe)
  var KEY_LAST = 'pnvideo_last';     // dernier niveau non nul, pour retablir apres un rechargement en muet
  function loadVol() {
    try {
      var v = localStorage.getItem(KEY);
      if (v === null) return null;
      v = parseFloat(v);
      return (isFinite(v) && v >= 0 && v <= 1) ? v : null;
    } catch (e) { return null; }
  }
  function saveVol(v) {
    try {
      localStorage.setItem(KEY, String(v));
      if (v > 0.05) localStorage.setItem(KEY_LAST, String(v));
    } catch (e) {}
  }
  function loadLast() {
    try { var v = parseFloat(localStorage.getItem(KEY_LAST)); return (isFinite(v) && v > 0.05 && v <= 1) ? v : null; }
    catch (e) { return null; }
  }
  function round2(v) { return Math.round(Math.max(0, Math.min(1, v)) * 100) / 100; }

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), x = Math.floor(s % 60);
    return m + ':' + (x < 10 ? '0' : '') + x;
  }

  function enhance(video) {
    if (!video || video.dataset.pnv) return;
    var host = video.parentElement;
    if (!host) return;

    video.dataset.pnv = '1';
    video.removeAttribute('controls');
    video.controls = false;
    host.classList.add('pnv');
    if (!host.hasAttribute('tabindex')) host.setAttribute('tabindex', '0');

    /* UN SEUL enfant direct (.pnv__ui) : le conteneur de Dawn porte la classe
       .media, et base.css force tous ses enfants directs en bloc plein cadre
       (`.media > *:not(.zoom):not(...)`, plus fort que nos selecteurs).
       Ce wrapper absorbe cette regle ; la barre, a l'interieur, n'est pas touchee. */
    var ui = document.createElement('div');
    ui.className = 'pnv__ui';
    ui.innerHTML =
      '<button type="button" class="pnv__big" aria-label="Lecture">' + ICON.play + '</button>' +
      '<div class="pnv__bar">' +
        '<button type="button" class="pnv__play" aria-label="Lecture / pause">' + ICON.play + '</button>' +
        '<div class="pnv__progress" role="slider" aria-label="Progression">' +
          '<div class="pnv__fill"></div><div class="pnv__tip">0:00</div>' +
        '</div>' +
        '<span class="pnv__time">0:00 / 0:00</span>' +
        '<div class="pnv__vol">' +
          '<button type="button" class="pnv__btn pnv__volbtn" aria-label="Volume"></button>' +
          '<div class="pnv__volpop"><div class="pnv__voltrack"><div class="pnv__volfill"></div></div></div>' +
        '</div>' +
        '<button type="button" class="pnv__btn pnv__fs" aria-label="Plein ecran">' + ICON.fs + '</button>' +
      '</div>';
    host.appendChild(ui);

    function $(s) { return host.querySelector(s); }
    var big = $('.pnv__big'), play = $('.pnv__play'),
        prog = $('.pnv__progress'), fill = $('.pnv__fill'), tip = $('.pnv__tip'), time = $('.pnv__time'),
        vol = $('.pnv__vol'), volBtn = $('.pnv__volbtn'), volTrack = $('.pnv__voltrack'), volFill = $('.pnv__volfill'),
        fsBtn = $('.pnv__fs');

    function dur() { return isFinite(video.duration) ? video.duration : 0; }

    /* ════════ VOLUME ════════ */
    var saved = loadVol();
    var startVol = saved === null ? 0.7 : saved;
    video.volume = startVol;
    video.muted = (startVol === 0);
    var lastVol = startVol > 0.05 ? startVol : (loadLast() || 0.7);
    var draggingVol = false, hideT = null;

    function curVol() { return video.muted ? 0 : video.volume; }
    function paintVol(v) {
      volFill.style.height = (v * 100) + '%';
      volBtn.innerHTML = v === 0 ? ICON.mute : ICON.vol;
    }
    function setVol(v) {
      v = round2(v);
      video.volume = v;
      video.muted = (v === 0);
      if (v > 0.05) lastVol = v;
      paintVol(v);
      saveVol(v);
    }
    paintVol(curVol());

    /* popup : ouvert au survol, ferme 200ms apres la sortie */
    function showPop() { clearTimeout(hideT); vol.classList.add('show'); }
    function hidePop(delay) {
      clearTimeout(hideT);
      hideT = setTimeout(function () { if (!draggingVol) vol.classList.remove('show'); }, delay);
    }
    vol.addEventListener('mouseenter', showPop);
    vol.addEventListener('mouseleave', function () { hidePop(200); });

    /* molette : +-5 %, popup visible 1 s */
    function onWheel(e) {
      e.preventDefault();
      e.stopPropagation();
      setVol(curVol() + (e.deltaY > 0 ? -0.05 : 0.05));
      showPop();
      if (!vol.matches(':hover')) hidePop(1000);
    }
    volBtn.addEventListener('wheel', onWheel, { passive: false });
    volTrack.addEventListener('wheel', onWheel, { passive: false });

    /* clic : couper / retablir le dernier niveau (> 5 %, sinon 70 %) */
    volBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (curVol() > 0) { lastVol = curVol(); setVol(0); }
      else setVol(lastVol > 0.05 ? lastVol : 0.7);
    });

    /* glisser : le son suit tout de suite, le visuel en requestAnimationFrame */
    var volRaf = null, pendingVol = 0;
    function volFromY(y) {
      var r = volTrack.getBoundingClientRect();
      return (r.bottom - y) / r.height;
    }
    function dragVol(y) {
      var v = round2(volFromY(y));
      video.volume = v;
      video.muted = (v === 0);
      if (v > 0.05) lastVol = v;
      saveVol(v);
      pendingVol = v;
      if (volRaf) return;
      volRaf = requestAnimationFrame(function () { volRaf = null; paintVol(pendingVol); });
    }
    volTrack.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      draggingVol = true;
      volTrack.setPointerCapture(e.pointerId);
      dragVol(e.clientY);
    });
    volTrack.addEventListener('pointermove', function (e) { if (draggingVol) dragVol(e.clientY); });
    function endVol(e) {
      if (!draggingVol) return;
      draggingVol = false;
      try { volTrack.releasePointerCapture(e.pointerId); } catch (x) {}
      if (!vol.matches(':hover')) hidePop(200);
    }
    volTrack.addEventListener('pointerup', endVol);
    volTrack.addEventListener('pointercancel', endVol);

    /* ════════ PROGRESSION ════════ */
    var raf = null, scrubbing = false, rect = null, pendingT = null, lastSeek = 0, scrubRaf = null, scrubX = 0;

    function paint() {
      if (scrubbing) return;
      var d = dur();
      fill.style.width = (d ? (video.currentTime / d) * 100 : 0) + '%';
      time.textContent = fmt(video.currentTime) + ' / ' + fmt(d);
    }
    function loop() { paint(); raf = requestAnimationFrame(loop); }
    function startLoop() { if (!raf) raf = requestAnimationFrame(loop); }
    function stopLoop() { if (raf) { cancelAnimationFrame(raf); raf = null; } paint(); }

    function pctAt(x, r) { return Math.max(0, Math.min(1, (x - r.left) / r.width)); }

    /* pendant le glisser : barre et temps immediats, video deplacee au plus
       ~8 fois/s (chaque deplacement coute un decodage) puis valide au relache */
    function scrubTo(x) {
      scrubX = x;
      if (scrubRaf) return;
      scrubRaf = requestAnimationFrame(function () {
        scrubRaf = null;
        if (!rect) return;
        var p = pctAt(scrubX, rect), d = dur();
        fill.style.width = (p * 100) + '%';
        pendingT = p * d;
        time.textContent = fmt(pendingT) + ' / ' + fmt(d);
        var now = performance.now();
        if (d && now - lastSeek > 120) {
          lastSeek = now;
          if (video.fastSeek) video.fastSeek(pendingT); else video.currentTime = pendingT;
        }
      });
    }
    prog.addEventListener('pointerdown', function (e) {
      if (!dur()) return;
      e.preventDefault();
      scrubbing = true;
      host.classList.add('is-scrubbing');
      rect = prog.getBoundingClientRect();
      prog.setPointerCapture(e.pointerId);
      lastSeek = 0;
      scrubTo(e.clientX);
    });
    prog.addEventListener('pointermove', function (e) {
      if (scrubbing) scrubTo(e.clientX);
      showTip(e.clientX);
    });
    function endScrub(e) {
      if (!scrubbing) return;
      var d = dur();
      if (rect && d) video.currentTime = pctAt(e.clientX, rect) * d;   // position exacte du relache
      scrubbing = false;
      host.classList.remove('is-scrubbing');
      rect = null;
      pendingT = null;
      try { prog.releasePointerCapture(e.pointerId); } catch (x) {}
      if (!prog.matches(':hover')) tip.style.opacity = '0';
      paint();
    }
    prog.addEventListener('pointerup', endScrub);
    prog.addEventListener('pointercancel', endScrub);

    /* infobulle : temps sous le curseur */
    function showTip(clientX) {
      var d = dur();
      if (!d) return;
      var r = rect || prog.getBoundingClientRect();
      var x = Math.max(0, Math.min(r.width, clientX - r.left));
      tip.textContent = fmt((x / r.width) * d);
      tip.style.left = x + 'px';
      tip.style.opacity = '1';
    }
    prog.addEventListener('mouseleave', function () { if (!scrubbing) tip.style.opacity = '0'; });

    /* ════════ LECTURE ════════ */
    function toggle() {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else video.pause();
    }
    function setPlayIcon() {
      var paused = video.paused;
      host.classList.toggle('is-paused', paused);
      play.innerHTML = paused ? ICON.play : ICON.pause;
    }
    play.addEventListener('click', toggle);
    big.addEventListener('click', toggle);
    video.addEventListener('click', toggle);

    video.addEventListener('play', function () { setPlayIcon(); startLoop(); });
    video.addEventListener('pause', function () { setPlayIcon(); stopLoop(); });
    video.addEventListener('ended', function () { setPlayIcon(); stopLoop(); });
    video.addEventListener('loadedmetadata', paint);
    video.addEventListener('durationchange', paint);
    video.addEventListener('seeked', paint);   // saut pendant la pause : la barre suit
    video.addEventListener('volumechange', function () { if (!draggingVol) paintVol(curVol()); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopLoop(); else if (!video.paused) startLoop();
    });

    /* ════════ PLEIN ECRAN ════════ */
    fsBtn.addEventListener('click', function () {
      if (document.fullscreenElement === host) { document.exitFullscreen(); return; }
      if (host.requestFullscreen) host.requestFullscreen();
      else if (host.webkitRequestFullscreen) host.webkitRequestFullscreen();
    });
    document.addEventListener('fullscreenchange', function () {
      fsBtn.innerHTML = (document.fullscreenElement === host) ? ICON.fsx : ICON.fs;
    });

    /* ════════ CLAVIER (lecteur focus) ════════ */
    host.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === ' ' || k === 'k') { e.preventDefault(); toggle(); }
      else if (k === 'm') { volBtn.click(); }
      else if (k === 'f') { fsBtn.click(); }
      else if (k === 'ArrowRight') { e.preventDefault(); video.currentTime += 5; paint(); }
      else if (k === 'ArrowLeft') { e.preventDefault(); video.currentTime -= 5; paint(); }
      else if (k === 'ArrowUp') { e.preventDefault(); setVol(curVol() + 0.05); }
      else if (k === 'ArrowDown') { e.preventDefault(); setVol(curVol() - 0.05); }
    });

    /* ════════ MASQUAGE AUTO DE LA BARRE ════════
       Elle apparait quand la souris BOUGE sur la video, et disparait
       apres 2 s d'immobilite (ou 250 ms apres la sortie). Jamais pendant
       un glisser, ni tant que la souris est posee sur la barre.
       En pause, elle reste visible (via .is-paused, cote CSS). */
    var bar = host.querySelector('.pnv__bar'), idleT = null, overBar = false;
    function sleep() {
      if (scrubbing || draggingVol || overBar) { idleT = setTimeout(sleep, 800); return; }
      host.classList.remove('is-active');
      vol.classList.remove('show');
    }
    function wake() {
      host.classList.add('is-active');
      clearTimeout(idleT);
      idleT = setTimeout(sleep, 2000);
    }
    host.addEventListener('mousemove', wake);
    host.addEventListener('mouseleave', function () { clearTimeout(idleT); idleT = setTimeout(sleep, 250); });
    bar.addEventListener('mouseenter', function () { overBar = true; });
    bar.addEventListener('mouseleave', function () { overBar = false; });

    setPlayIcon();
    paint();
    if (!video.paused) startLoop();
  }

  /* ── la video est injectee au clic sur le poster : on l'attend ── */
  function waitFor(host) {
    var tries = 0;
    (function check() {
      var v = host.querySelector('video');
      if (v) { enhance(v); return; }
      if (tries++ < 90) requestAnimationFrame(check);
    })();
  }
  document.addEventListener('click', function (e) {
    var poster = e.target.closest && e.target.closest('.deferred-media__poster');
    if (!poster) return;
    var host = poster.closest('deferred-media') || poster.parentElement;
    if (host) waitFor(host);
  }, true);

  function initExisting() {
    document.querySelectorAll('deferred-media video, .product-media-container video').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initExisting);
  else initExisting();
  document.addEventListener('shopify:section:load', initExisting);
})();
